module.exports = __webpack_public_path__ + "img/imgstep4.39976141.svg";